<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-xl-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka's
                            <br>Accomplishments</h1>
                        <p>Trinka has been contributing its bit to the AI industry by publishing
                            <br> research papers and e-posters. This wall is dedicated to all the
                            <br>accomplishments that Trinka has achieved so far.
                        </p>
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/eposter.png" alt="eposter">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="tabsDesign">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="pill" href="#Year2025">2025</a>
                          </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#Year2024">2024</a>
                          </li>
                        <li class="nav-item">
                          <a class="nav-link" data-toggle="pill" href="#Year2023">2023</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" data-toggle="pill" href="#Year2022">2022</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#Year2021">2021</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#Year2020">2020</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    <section class="section-md" style="padding-top: 35px;">
        <div class="container">
            <div class="tab-content">
                <div class="tab-pane active" id="Year2025">
                    <div class="row match-box">
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/enago-launches-documark-for-universities-to-address-ai-assisted-student-work']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2025/DocuMark.webp" class="img-fluid" alt="DocuMark Press Release" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Enago Launches DocuMark: A Breakthrough Tool that Redefines How Universities Address AI-Assisted Student Work</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">May 19, 2025</p> 
                                                <p>The new platform relieves faculty from detection burden while empowering students to take ownership of AI contributions.</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/abec-partners-with-trinka-to-provide-ai-powered-scientific-writing-assistance-for-1100-plus-members-across-brazil']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2025/ABEC-banner.webp" class="img-fluid" alt="ABEC Partners with Trinka" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>ABEC Partners with Trinka to Provide AI-powered Scientific Writing Assistance for 1,100+ Members Across Brazil</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">​São Paulo, Brazil – April 7, 2025​</p> 
                                                <p>The Brazilian Association of Scientific Editors (ABEC Brazil) is excited to announce a strategic partnership with Trinka AI, a leading AI-powered writing assistant specializing in academic and technical writing.</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/cbua-introduces-trinka-ai-writing-assistance-for-its-10-member-universities-in-spain']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2025/CBUA.png" class="img-fluid" alt="CBUA Partners" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>CBUA Introduces Trinka’s AI Writing Assistance for Its 10 Member Universities in Spain</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">Córdoba, Spain – March 05, 2025</p> 
                                                <p>The Consorcio de Bibliotecas Universitarias de Andalucía (CBUA), representing ten major universities in Spain, has partnered with Trinka AI to provide an advanced AI-powered writing assistant to students and faculty across its institutions. </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/university-of-johannesburg-library-extends-partnership-with-trinka-ai']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2025/university-of-johannesburg.png" class="img-fluid" alt="University of Johannesburg" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>University of Johannesburg Library Extends Partnership with Trinka AI—To Offer AI Writing & Literature Review Tools </h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">Johannesburg, February 26, 2025 </p> 
                                                <p>The University of Johannesburg (UJ) Library is pleased to announce the extension of its collaboration with Trinka AI, a leading AI-powered writing assistance platform.</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/trinka-ai-recognized-by-gartner-as-an-emerging-visionary-in-generative-ai']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2025/generative-ai-technologies.png" class="img-fluid" alt="Generative AI Technologies" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Trinka AI Recognized by Gartner as an Emerging Visionary in Generative AI</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">February 25, 2025</p> 
                                                <p>Trinka AI (Crimson Interactive) is recognized by Gartner®, the world's leading research and advisory firm, as an Emerging Visionary in the 2025 Innovation Guide for Generative AI Technologies.</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/trinka-introduces-the-sensitive-data-plan-promising-unmatched-data-privacy']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2025/sensitive-plan.webp" class="img-fluid" alt="sensitive plan" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Trinka Introduces the Sensitive Data Plan Promising Unmatched Data Privacy</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">Mumbai, India – January 20, 2025 </p> 
                                                <p>Amidst the growing concerns surrounding data privacy, Trinka has released its “Sensitive Data Plan”, a groundbreaking offering customized for both business and individual users requiring the highest level of data security and privacy.</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/myrma-collaborates-with-trinka-ai-to-enhance-research-excellence-in-malaysia']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2025/MyRMA.png" class="img-fluid" alt="MyRMA Collaborates" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>MyRMA Collaborates with Trinka AI to Offer AI Writing Assistance to 25+ Member Institutions Across Malaysia</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">Kuala Lumpur, Malaysia – January 10, 2025 </p> 
                                                <p>The Malaysian Association of Research Managers and Administrators (MyRMA) announces a strategic partnership with Trinka AI, a leading AI-powered writing assistant specializing in academic and technical writing.  </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <!-- Year2024 -->
                <div class="tab-pane" id="Year2024">
                    <div class="row match-box">
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/trinka-citation-formatter-simplifying-citation-formatting-for-authors']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2024/citation-formatter.png" class="img-fluid" alt="citation formatter" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Trinka’s Citation Formatter: Simplifying Citation Formatting for Authors</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">Dec 30, 2024, India</p> 
                                                <p>Formatting citations for academic manuscripts is often a daunting task for authors, involving complex guidelines, time-consuming revisions, and frequent rejections.</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/trinka-windows-app-update']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2024/windows-app.png" class="img-fluid" alt="window-app" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Trinka Introduces New Features for a Better Writing Experience</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">Nov 28, 2024, India</p> 
                                                <p>Trinka.AI has launched updates to improve user experience and accessibility. </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/trinka-introduces-latex-proofreader-for-latex-documents']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2024/latex-proofreader.png" class="img-fluid" alt="Interactive Awarded" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Trinka Introduces LaTeX Proofreader for LaTeX Documents</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">May 21, 2024, India</p> 
                                                <p>Trinka has announced the launch of LaTeX  Proofreader. This new tool proofreads LaTeX documents and aims at  enhancing the writing and editing process for the academic community. </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/crimson-interactive-awarded-as-great-place-to-work']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../../assets/images/news/2024/crimson-best-place.png" class="img-fluid" alt="Interactive Awarded" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Crimson Interactive Awarded As Great Place To Work®</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">February 16, 2024, India</p> 
                                                <p>Crimson Interactive is thrilled to announce its remarkable achievement of the esteemed Great Place To Work® Certification. This award is a powerful symbol of our shared commitment at Crimson. It shows that we've built a place where everyone feels valued and respected, not just in words, but in our everyday actions.</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/trinka-responds-to-growing-demand-for-inclusive-communication-with-its-latest-feature-inclusive-language-check']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2024/inclusive-language.png" loading="lazy" class="img-fluid" alt="inclusive-language">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Trinka Responds to Growing Demand for Inclusive Communication with its latest feature Inclusive Language Check</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">February 13, 2024, India</p> 
                                                <p>In a world where the conversation around diversity and inclusivity is more prominent than ever, there's a growing demand for tools that encourage understanding and respectful communication. In acknowledgement  to this critical need, Trinka has introduced its Inclusive Language Check, contributing significantly to the movement towards more equitable and inclusive dialogue across various platforms. </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="tab-pane" id="Year2023">
                    <div class="row match-box">
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/trinka-ai-introduces-ai-content-detector-to-elevate-writing-integrity']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2023/ai-content-detector.png" class="img-fluid" alt="AI Content Detector">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Trinka AI Introduces AI Content Detector to Elevate Writing Integrity</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">September 20, 2023, New York</p> 
                                                <p>Trinka AI has announced the latest addition to its suite of offerings: the AI Content Detector. This is a conscious effort to respond to the ethical grey area that has been created in the field of education due to the increasing prevalence of AI-generated content.</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/trinka-ai-introduces-paraphrasing-tool']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2023/Paraphraser.png" class="img-fluid" alt="Trinka AI">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Trinka AI Introduces Paraphrasing Tool</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">September 15, 2023, New York</p> 
                                                <p>Trinka AI has introduced a new feature to its suite - the Paraphrasing Tool, known as Trinka Paraphraser. This AI-powered tool harnesses advanced natural language processing (NLP) techniques, enabling users to generate high-quality and coherent paraphrases while preserving the original meaning. </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/trinka-ai-introduces-sensitive-data-plan-for-enterprises']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Trinka AI Introduces Sensitive Data Plan for Enterprises</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">September 10, 2023, New York</p> 
                                                <p>Trinka AI has introduced a special offering for enterprises named “Sensitive Data Plan”, maximizing  security and confidentiality for written content.  </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/enago-launches-enago-reports-a-suite-of-ai-powered-reports-to-assess-and-enhance-documents-within-minutes']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2023/enago-reports.png" class="img-fluid" alt="enago reports">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Enago Launches Enago Reports, a Suite of AI-powered Reports to Assess & Enhance Documents within Minutes</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p></p>
                                                <p class="date">August 22 2023, New York</p> 
                                                <p>Enago Reports has recently become part of Enago's suite of AI-powered products, alongside Trinka AI and Enago Read. Enago Reports provides a comprehensive range of bespoke reports to enhance the quality of content, integrity and impact of various documents through the use of AI technology.</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/enago-announces-the-official-rebranding-of-rAxter-io-to-enago-read']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2023/new-identity.png" class="img-fluid" alt="Rebranding">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Enago Announces the Official Rebranding of RAxter.io to Enago Read</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>Enago announces the official rebranding of RAxter.io to Enago Read. This transformation marks the culmination of a vision initiated in 2021 when Enago acquired the US-based organization, RAxter.io, with a mission to simplify the research process for scholars worldwide through Artificial Intelligence (AI) and Natural Language Processing (NLP).  </p>
                                                <p class="date">August 22 2023, New York</p> 
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/enago-read-launches-copilot-an-ai-powered-assistant']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2023/reading-ai.png" class="img-fluid" alt="AI-powered Assistant">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Enago Read Launches Copilot: An AI-powered Assistant</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>Enago Read has announced the launch of Copilot, an AI-powered assistant that can process any scientific paper with the help of a Large Language Model and will be able to provide assistance quickly. Copilot provides a simple, easy to use, chat-like interface with multilingual capabilities. </p>
                                                <p class="date">August 10 2023, New York</p> 
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row match-box">
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/trinka-wins-the-first-runner-up-for-innovation-in-ai-for-education-at-the-aegis-graham-bell-awards']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2023/aieges.jpg" class="img-fluid" alt="Trinka wins the first runner-up for ‘Innovation in AI for Education’ at the Aegis Graham Bell Awards">
                                        </div>
                                    </div>
                    
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Trinka wins the first runner-up for ‘Innovation in AI for Education’ at the Aegis Graham Bell Awards</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>Crimson AI was recognized at the 13<sup>th</sup> edition of the prestigious Aegis Graham Bell Awards for ‘Innovation in AI for Education’. This award was for Trinka, an AI-powered writing assistant that is tailored to specifically address the needs of researchers who use English as a second language. </p>
                                                <p class="date">February 2023</p> 
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                
                <div class="tab-pane" id="Year2022">
                    <div class="row match-box">
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/crimson-interactive-acquires-the-charlesworth-group']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2022/news-banner-2A.jpg" alt="Crimson Interactive (Enago) acquires The Charlesworth Group, creating a powerhouse in China’s publishing ecosystem." class="img-fluid eposter-img">
                                        </div>
                                    </div>
                    
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Crimson Interactive (Enago) acquires The Charlesworth Group, creating a powerhouse in China’s publishing ecosystem.</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>The acquisition provides the Charlesworth Group and Enago with the scope to build solutions to successfully address researcher and publisher challenges, in particular, assisting publishers to navigate the transition towards Open Access in China.</p>
                                                <p class="date">November 2022</p> 
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/sharad-mittal-wins-et-global-indian-leaders-awards-for-excellence-in-ai-nlp']" routerLinkActive="active" class="newsSection">
                                <div class="row flex-row-reverse align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2022/Excellence_AI_5f4cfeb8b3.png" alt="Sharad Mittal wins ET Global Indian Leaders Awards 2022 for Excellence in AI & NLP" class="img-fluid eposter-img">
                                        </div>
                                    </div>
                    
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Sharad Mittal wins ET Global Indian Leaders Awards 2022 for Excellence in AI & NLP</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>Crimson Interactive’s Founder and CEO was felicitated by Dia Mirza at the award ceremony in recognition of the immense impact of the company’s Artificial Intelligence (AI) and Natural Language Processing (NLP)</p>
                                                <p class="date">November 2022</p> 
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/national-best-employer-brand-award']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2022/crimsonnationalbestemployeraward.png" alt="Crimson Interactive wins ‘National Best Employer Brand Award’ at the 30th HRD Congress" class="img-fluid eposter-img">
                                        </div>
                                    </div>
                    
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Crimson Interactive wins ‘National Best Employer Brand Award’ at the 30th HRD Congress</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>Crimson Interactive wins ‘National Best Employer Brand Award’ at the 30th HRD Congress
                                                </p>
                                                <p class="date">June 2022</p> 
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/role-and-impact-of-ai-on-the-future-of-academic-publishing']" routerLinkActive="active" class="newsSection">
                                <div class="row align-items-center flex-row-reverse">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2022/enago-survey-report.jpg" alt="Role and Impact of AI on the Future of Academic Publishing: A Global Survey Report by Enago" class="img-fluid eposter-img">
                                        </div>
                                    </div>
                    
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Role and Impact of AI on the Future of Academic Publishing: A Global Survey Report by Enago</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>350+ respondents from 212 universities across 54 countries guide all academic stakeholders
                                                </p>
                                                <p class="date">March 2022</p> 
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/iiitd-partners-with-rax-by-enago']" routerLinkActive="active" class="newsSection">
                                <div class="row">
                                    <!-- <div class="col-md-6">
                                        <div class="accomplishSections_img">
                                            <img src="../../../assets/images/news/2022/enago-survey-report.jpg" alt="IIITD partners with Research Assistant RAx (by Enago), to promote AI-based research for students" class="img-fluid eposter-img">
                                        </div>
                                    </div> -->
                    
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>IIITD partners with Research Assistant RAx (by Enago), to promote AI-based research for students</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>RAx will sponsor and support select Ph.D scholars for their explore research problems in the field of NLP, Recommendation Systems, and Knowledge Graphs.
                                                </p>
                                                <p class="date">March 2022</p> 
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/free-academic-phrasebank-launched-by-trinka']" routerLinkActive="active" class="newsSection">
                                <div class="row">
        
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Free Academic Phrasebank Launched<br class="d-lg-block d-none"/> by Trinka AI</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>The Most Comprehensive Free Academic Database in the World to Facilitate Research Writing
                                                </p>
                                                <p class="date">June 2022</p> 
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                    </div>
                        
                </div>

                <div class="tab-pane" id="Year2021">
                    <div class="row match-box">
                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/crimson-interactive-wins-asias-best-employer-brand-award-2021']" routerLinkActive="active" class="newsSection">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <p>Awards</p>
                                            <img src="../../../assets/images/winner_of_asia.png" alt="winner asia" class="img-fluid eposter-img">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Awarded 'Asia's Best Employer Brand Award 2021</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>Crimson Interactive, the parent of Trinka AI, has been awarded Asia's Best Employer for 2021 by the
                                                    Employer Branding Institute. A special jury council honored Crimson's HR initiatives that prioritize
                                                    employee wellbeing over everything else.</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-6 dflex">
                            <a [routerLink]="['/news/crimson-interactive-has-been-awarded-employer-of-the-year-2021']" routerLinkActive="active" class="newsSection">
                                <div class="row ">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <p>Awards</p>
                                            <img src="../../../assets/images/employer_of_the_year.png" alt="award" class="img-fluid eposter-img">
                                        </div>
                                    </div>
                    
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Awarded 'Employer of the Year 2021'</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>Crimson Interactive, the parent company of Enago and Trinka is awarded 'Employer of the year 2021' by Stevie. 12,000 applications from 70+ countries had participated. Our employee-centric initiatives enthralled their specialized jury of 70+ professionals at an international platform.
                                                </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-6 dflex">
                            <a href="../../../assets/resources/paper24.pdf" target="_blank" rel="noopener noreferrer" class="newsSection">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <p>Research Paper</p>
                                            <div class="accomplishpdfText">Effective Ensembling of Transformer based Language Models for Acronyms Identification</div>
                                            
                                                <img src="../../../assets/images/ai-pdf.png" alt="pdf" class="img-fluid no-shadow">
                                        </div>
                                    </div>
                    
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>Research Paper Submission for SDU@AAAI-21</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>We have proposed an approach that solves the Acronym identification task which was a shared task for SDU@AAAI-21. We treated this task as a sentence labeling problem. The proposed method is computed by the ensemble for various language models trained by hyper-parameter tuning. This ensembling technique is then coupled with post-processing steps to extract the best possible predictions.
                                                </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-6 dflex">
                            <a href="" data-toggle="modal" data-target="#accomplishPopup" id="VewiVideoSection"  class="newsSection">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <p>ePoster</p>
                                                <img src="../../../assets/images/eposter-thumbnail1.png" alt="eposter" class="img-fluid eposter-img">
                                        </div>
                                    </div>
                    
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>ePoster for ISMPP EU 2021</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>We presented a poster at the virtual 2021 European Meeting of the International Society for Medical
                                                    Publication Professionals (ISMPP), London.
                                                </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                    </div>

                </div>
                <div class="tab-pane" id="Year2020">
                    <div class="row">
                        <div class="col-md-6 dflex">
                            <a href="" data-toggle="modal" data-target="#accomplishPopup1" class="newsSection">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="accomplishSections_img">
                                            <p>ePoster</p>
                                                <img src="../../../assets/images/eposter-thumbnail2.png" alt="eposter" class="img-fluid eposter-img">
                                            
                                        </div>
                                    </div>
                    
                                    <div class="col-md-12">
                                        <div class="newsBody">
                                            <div class="section-title">
                                                <h2>ePoster for ISMPP EU 2020</h2>
                                                <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                                <p>We presented our AI technology at the 2020 European Meeting of the International Society for Medical
                                                    Publication Professionals (ISMPP), London. Our poster "AI-based Manuscript Assessment Tool (MAT)
                                                    Aids in Quality Check and Reduces Time to Journal Submission" was selected for an oral presentation.
                                                </p>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <div class="forpersonlized_sections newsletterSection">
        <div class="container">
            <div class="row">
                <div class="col-md-7">
                    <div class="forpersonlized_sectionsLeft">
                        <h3>Subscribe to stay updated with us!</h3>
                        <p>Join thousands of subscribers to get regular updates on industry trends and our blog posts.
                        </p>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="forpersonlized_sectionsRight">
                        <form (ngSubmit)="subscribeNow()" [formGroup]="accomForms">
                            <div class="textbox_content form-group" [ngClass]="(!accomForms.get('accomemailForms').valid && accomForms.get('accomemailForms').dirty) || (accomForms.get('accomemailForms').touched && accomForms.get('accomemailForms').pristine) ? 'TextFiledError' : '' ">
                                <input placeholder="Your Email ID" formControlName="accomemailForms" class="form-control">
                            </div>
                            <button id="accomSubscribe">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">Use Trinka in Other Apps</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content_overlay"></div>
                                <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="icon">
                                <h3>Cloud</h3>
                            </a>
                        </li>
                        <li>
                            <a  [routerLink]="['/windows-desktop-app']">
                                <div class="app_name_content_overlay"></div>
                                <img src="../../../assets/images/native-app/windows-icon.svg" alt="windows">
                                <h3>Windows App</h3>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content_overlay"></div>
                                <img src="../../../assets/images/Others_App_MSWord.svg" alt="icon">
                                <h3>MS Word Add-in</h3>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content_overlay"></div>
                                <img src="../../../assets/images/other_Apps_browser.svg" alt="icon">
                                <h3>Browser Plug-in</h3>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content_overlay"></div>
                                <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="icon">
                                <h3>Enterprise <small>(API, JS, & On-Premise)</small></h3>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    
</div>

<!-- Modal -->
<div class="modal fade" id="accomplishPopup" tabindex="-1" role="dialog" aria-labelledby="accomplishPopupLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>
                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="accomplishPopup1" tabindex="-1" role="dialog" aria-labelledby="accomplishPopupLabel1" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>
                <iframe width="100%" height="450" src="https://www.youtube.com/embed/mj_NeFhN6v0" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>